import { InjectionToken, signal, type Signal } from '@angular/core';
import { ReplaySubject, type Observable } from 'rxjs';
import type { DialogResult } from '../../components/dialog';

export interface PopoverRef<TResult extends DialogResult = DialogResult> {
    afterClosed(): Observable<TResult>;
    close(result?: TResult): void;
    readonly closed: Signal<boolean>;
}

export const QPX_POPOVER_REF = new InjectionToken<PopoverRef>(
    'QPX_POPOVER_REF'
);

export class QpxPopoverOverlayRef<
    TResult extends DialogResult = DialogResult,
> implements PopoverRef<TResult> {
    private readonly closed$ = new ReplaySubject<TResult>(1);
    private readonly isClosed = signal(false);
    public readonly closed = this.isClosed.asReadonly();

    constructor(
        private readonly disposeOverlay: () => void,
        private readonly destroyInjector: () => void
    ) {}

    public afterClosed(): Observable<TResult> {
        return this.closed$.asObservable();
    }

    public close(result = false as TResult): void {
        if (this.isClosed()) return;

        this.isClosed.set(true);
        this.disposeOverlay();
        this.destroyInjector();
        this.closed$.next(result);
        this.closed$.complete();
    }
}
